import RetoolComp from '../retool_components/retool';

export const Filtering = () => {
  const filtering_uuid = '4078e83c-5249-11ee-9ada-f3952056a5a6';
  return <RetoolComp component_uuid={filtering_uuid} />;
};
